import { BaseClient } from '../client';
import { TRevenda } from '../shopkeeper';

interface postBuyerResponse {
	id: number;
}

export const postBuyer = async (requestBody: Partial<TRevenda>) => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return 1234;
	// }

	try {
		const response = await BaseClient.post<postBuyerResponse>(
			`/Admin/CreateAdminRevenda`,
			requestBody
		).then((response) => response.data);

		return response;
	} catch (error) {
		throw error;
	}
};
